import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../../shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
declare const $: any;
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { emailPattern, noWhitespaceInRequiredValidator, mobilePattern } from '../../../shared/constants';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-clinic-form',
	templateUrl: './clinic-form.component.html',
	styleUrl: './clinic-form.component.css'
})
export class ClinicFormComponent implements OnInit {
	moduleForm!: FormGroup;
	showLoader = false;
	pageLoading = false;
	@Input() uId: any = null;
	@Output() created = new EventEmitter<any>();
	@Output() cleared = new EventEmitter<any>();
	customError: any = {};
	UserModuleAccess: any = "Full";
	formSubmitted = false;
	countries: any = [];

	constructor(private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute) {
		this.moduleForm = this.formBuilder.group({
			clinic_id: [null, [Validators.required]],
			clinic_name: [null, [Validators.required]],
			address: [null, [Validators.required]],
			email_id: [null, [Validators.required, Validators.pattern(emailPattern)]],
			phone_no: [null, [Validators.required, Validators.pattern(mobilePattern)]],
			countryCode: [null, [Validators.required]],
		});
	}

	get f() { return this.moduleForm.controls; }

	ngOnInit(): void {
		this.getCountryCodes();
		if (this.uId) {
			this.getDetails();
		}
	}

	getCountryCodes() {
		this.apiService.countryCodes().subscribe({
			next: (data: any) => {
				data.map((c: any) => {
					c.display = c.dial_code + "(" + c.name + ")"
					return c;
				})
				this.countries = data;
			}, error: () => {
				this.countries = [];
			}
		});
	}

	customSearchFn(term: string, item: any) {
		term = term.toLocaleLowerCase();
		if (item.dial_code != null && item.name != null) {
			return item.dial_code.toLocaleLowerCase().indexOf(term) > -1 || item.name.toLocaleLowerCase().indexOf(term) > -1;
		} else if (item.dial_code != null) {
			return item.dial_code.toLocaleLowerCase().indexOf(term) > -1;
		} else {
			return item.name.toLocaleLowerCase().indexOf(term) > -1
		}
	}

	clearForm() {
		this.moduleForm.reset();
		this.cleared.emit();
	}

	getDetails() {
		this.pageLoading = true;
		this.apiService.getClinicDetails(this.uId).subscribe({
			next: (data: any) => {
				this.pageLoading = false;
				this.f.clinic_id.setValue(data.clinic_id);
				this.f.clinic_name.setValue(data.clinic_name);
				this.f.email_id.setValue(data.email_id);
				this.f.address.setValue(data.address);
				this.f.phone_no.setValue(data.phone_no);
				this.f.countryCode.setValue(data.countryCode);
			}, error: (error) => {
				this.pageLoading = false;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	clearCustomError() {
		Object.keys(this.f).forEach(key => {
			if (this.f[key].hasError('incorrect')) {
				try {
					delete this.f[key].errors?.incorrect;
					this.f[key].updateValueAndValidity();
				} catch (error) { }
			}
		});
		this.customError = {};
	}

	saveData() {
		this.formSubmitted = true;
		this.clearCustomError();
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required parameters.", 'Warning', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}

		let payload = {
			"address": this.f.address.value,
			"clinic_id": this.f.clinic_id.value,
			"clinic_name": this.f.clinic_name.value,
			"email_id": this.f.email_id.value,
			"phone_no": this.f.phone_no.value,
			"countryCode": this.f.countryCode.value,
			"id": this.uId
		}
		this.showLoader = true;
		this.apiService.createUpdateClinic(payload).subscribe({
			next: (data: any) => {
				this.showLoader = false;
				this.toastr.success("Clinic saved successfully", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.created.emit(data);
				this.clearForm();
			}, error: (error) => {
				this.showLoader = false;
				if (error.status == 409) {
					Swal.fire({
						title: 'Already Exists',
						html: 'Clinic with name <strong>' + this.f.clinic_name.value + '</strong> already exists. Do you want to restore it?',
						icon: 'question',
						showCancelButton: true,
						showConfirmButton: true,
						confirmButtonText: 'Yes, Restore!',
						cancelButtonText: 'Cancel',
						confirmButtonColor: '#3e4fb1'
					}).then((result) => {
						if (result.value) {
							this.apiService.restoreClinic(error.error.id).subscribe({
								next: (data: any) => {
									this.toastr.success("Clinic restored successfully", 'Success', {
										timeOut: 3000,
										tapToDismiss: true,
										closeButton: true
									});
									this.created.emit(data);
									this.clearForm();
								}, error: (error) => {
									this.toastr.error("Something went wrong", 'Error', {
										timeOut: 3000,
										tapToDismiss: true,
										closeButton: true
									});
								}
							});
						}
					})
				} else {
					let errorMsg = "Something went wrong.";
					if (error.status == 400) {
						errorMsg = "Clinic name already exists";
					}
					this.toastr.error(errorMsg, 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true,
					});
				}
			}
		});
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}
}
